// import { useRef, useEffect } from 'react';

// export const useApiAbort = () => {
//     const abortController = useRef<AbortController>(new AbortController());

//     useEffect(() => {
//         const abortCtrl = abortController.current;
//         return () => {
//             abortCtrl.abort();
//         };
//     }, []);

//     return abortController;
// };

// export default useApiAbort;
import { useRef } from 'react';

export const useApiAbort = () => {
    // Create AbortController only once and reuse it
    const abortControllerRef = useRef<AbortController>(new AbortController());

    return abortControllerRef;
};

export default useApiAbort;
